module.exports = __webpack_public_path__ + "img/message-unread.64dcb680.svg";